module.exports = __webpack_public_path__ + "static/media/sel_06_241.e3784c84.mp4";